// extracted by mini-css-extract-plugin
export default {"root":"AddressFields_root__OswWi","row":"AddressFields_row__A8Q5-","postalCode":"AddressFields_postalCode__42ZzN","city":"AddressFields_city__l7qKL"};